import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {filter, first, switchMap} from "rxjs/operators";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {SecurityIgnoredIssue} from './security-ignored-issue';

@Injectable()
export class SecurityIgnoredIssuesResolver implements Resolve<null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
      const _childWebsiteId = route.parent.data['website'].isNetwork && !route.parent.data['website'].parentId && route.parent.data['website'].children && route.parent.data['website'].children.length ? route.parent.data['website'].children[0] : null;
      this._store.select(fromStore.getSecurityIgnoredIssuesLoaded(_childWebsiteId || websiteId))
        .pipe(
          filter((loaded: boolean): boolean => loaded),
          switchMap(() => this._store.select(fromStore.getSecurityIgnoredIssues(websiteId))),
          first()
        )
        .subscribe((securityIgnoredIssues: SecurityIgnoredIssue[]) => {
          resolve(securityIgnoredIssues);
        });
    });
  }

}
